import controller from './agent.controller';
import template from './agent.html';

export default {
	controller,
	template,
	bindings: {},
};
